/* Little Signals sign-ups: shows the thank-you in the form that was sent, and runs the gentle pop-up. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var KEY_CLOSED = 'lsPopClosed', KEY_DONE = 'lsSubscribed', WAIT = 40000, AWAY_DAYS = 60;
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var posted = /[?&]customer_posted=true/.test(location.search);
  var sentId = (location.hash || '').slice(1);

  document.querySelectorAll('form[data-ls-su]').forEach(function (f) {
    if (posted && f.id && f.id === sentId) {
      f.classList.add('is-done');
      var row = f.querySelector('.ls-su__row'), note = f.querySelector('.ls-su__note'), done = f.querySelector('.ls-su__done');
      if (row) row.hidden = true;
      if (note) note.hidden = true;
      if (done) done.hidden = false;
      set(KEY_DONE, '1');
    }
    f.addEventListener('submit', function () { set(KEY_DONE, '1'); });
  });

  var pop = document.querySelector('[data-ls-pop]');
  if (!pop) return;
  function open() { pop.hidden = false; document.documentElement.classList.add('ls-pop-open'); var c = pop.querySelector('[data-ls-pop-close]'); if (c) c.focus(); }
  function close() { pop.hidden = true; document.documentElement.classList.remove('ls-pop-open'); if (!get(KEY_DONE)) set(KEY_CLOSED, String(Date.now())); }
  pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-ls-pop-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });

  if (posted && sentId === 'ls-pop-signup') { open(); return; }
  if (get(KEY_DONE)) return;
  var closedAt = +get(KEY_CLOSED) || 0;
  if (closedAt && Date.now() - closedAt < AWAY_DAYS * 864e5) return;
  if (/^\/(cart|checkout|checkouts|account|pages\/schools)/.test(location.pathname)) return;
  setTimeout(function () {
    var focused = document.activeElement;
    if (focused && /INPUT|TEXTAREA|SELECT/.test(focused.tagName)) return;
    open();
  }, WAIT);
})();
